import React from "react";
import "./OTPForm.scss";

import {MDBBox, MDBIcon, MDBTypography} from "mdbreact";
import OtpInput from "./SingleOtpInput";
import cogoToast from "cogo-toast";
import VerifyMoboilenoAndOtp from "../../mutations/VerifyMoboilenoAndOtp";
import {connect} from "react-redux";
import {setLoginStep, userLogin} from "../../Actions";
import LoginHeader from "../../component/LoginHeader/LoginHeader";
import RequestOtpMutation from "../../mutations/RequestOtpMutation";
import {Slide} from "react-reveal";
import {assetUrl} from "../../serviceApi";

const Phone = assetUrl+"images/login-mobile.png";
const NetaLogo = assetUrl+"images/neta-logo-sm.png";
const OpenMe = assetUrl+"images/open-me.png";
const tick = assetUrl+'images/animation_tick.svg'
const Vector = assetUrl+"images/Vector.svg";
const open_envlope = assetUrl+'images/onboarding_open_envelope.svg'

class OTPForm extends React.Component {
	constructor(props) {
		super(props);
		this.timer = 0;
		this.state = {
			otp: '',
			numInputs: 4,
			separator: '',
			isDisabled: false,
			hasErrored: false,
			isInputNum: false,
			loading: false,
			otpChecked: false,
			// triggerState: true,
			time: {},
			seconds: 60
		}
	}

	componentDidMount() {
		let timeLeftVar = this.secondsToTime(this.state.seconds);
		this.setState({
			time: timeLeftVar,
			triggerState: true
		}, () => {
			this.startTimer();
		});
	}

	secondsToTime(secs) {
		let hours = Math.floor(secs / (60 * 60));

		let divisor_for_minutes = secs % (60 * 60);
		let minutes = Math.floor(divisor_for_minutes / 60);

		let divisor_for_seconds = divisor_for_minutes % 60;
		let seconds = Math.ceil(divisor_for_seconds);

		let obj = {
			"h": hours,
			"m": minutes,
			"s": seconds
		};
		return obj;
	}

	startTimer() {
		if (this.timer === 0 && this.state.seconds > 0) {
			var self = this;
			this.timer = setInterval(function () {
				let seconds = self.state.seconds - 1;
				self.setState({
					time: self.secondsToTime(seconds),
					seconds: seconds,
				});

				// Check if we're at zero.
				if (seconds === 0) {
					clearInterval(self.timer);
				}
			}, 1000);
		}
	}

	handleOtpChange = otp => {
		this.setState({otp});
	};

	rippleEffect = (e) => {
		if (this.state.validated === false) {
			let x = e.clientX;
			let y = e.clientY;
			let buttonTop = e.target.offsetTop;
			let buttonLeft = e.target.offsetLeft;
			let xInside = x - buttonLeft;
			let yInside = y - buttonTop;

			let circle = document.createElement('span');
			circle.classList.add('mob-circle');
			// circle.style.top = yInside + 'px';
			circle.style.left = xInside + 'px';
			if (document.querySelector(".verify-otp-btn")) {

				document.querySelector(".verify-otp-btn").appendChild(circle);

				setTimeout(() => {

					circle.remove();

				}, 100);

			}
		}
	}

	handleSubmit = (e) => {
		this.rippleEffect(e)
		let data = {
			'mobileNumber': "+91" + this.props.user_details.mobileNumber,
			'otp': this.state.otp
		}
		let scope = this;
		if (this.state.otp === "" || this.state.otp.length < 4) {
			cogoToast.warn("please fill valid OTP", {position: 'top-center'});
		} else {
			this.setState({
				loading: true
			})
			VerifyMoboilenoAndOtp(data, function (response) {
				scope.setState({
					loading: false,
				})
				if (response.loginWithMobileNumber.error === false) {

					// cogoToast.success(response.loginWithMobileNumber.message, {position: 'top-center'});
					scope.setState({
						loading: false,
						otpChecked:true
					})
					setTimeout(() => {
						scope.setUserData(response);
					}, 1000)
				} else {
					if (response.loginWithMobileNumber.message === "Regenerate OTP") {
						scope.props.setLoginStep(1);
						scope.props.handleLoginSteps(1);
					} else {
						cogoToast.error(response.loginWithMobileNumber.message, {position: 'top-center'});
					}
				}
			}, function (err) {
				scope.setState({
					loading: false
				})
				cogoToast.error(err, {position: 'top-center'});
			});
		}
	}

	setUserData = (response) => {

		let login_step;
		let data = {
			user_details: {
				mobileNumber: this.props.user_details.mobileNumber,
				token: response.loginWithMobileNumber.token ? response.loginWithMobileNumber.token : "",
				welcomeBonus: 0,
				refreshToken: response.loginWithMobileNumber.refreshToken ? response.loginWithMobileNumber.refreshToken : "",
				user: {}
			},
			logged_in: false,
		}
		this.props.addUserData(data);

		if (response.loginWithMobileNumber.token) {
			login_step = 2;
			localStorage.setItem("token", response.loginWithMobileNumber.token);
			localStorage.setItem("refreshToken", response.loginWithMobileNumber.refreshToken);
		} else if (this.props.forgetPinIs) {
			login_step = 3;
		} else {
			login_step = 5;
		}
		this.props.initCircleRotation()
		this.setState({...this.state, triggerState: false})
		if (!this.state.triggerState) {
			setTimeout(() => {
				this.props.setLoginStep(login_step);
				this.props.handleLoginSteps(login_step);
			}, 1000)
		}

	}

	reSendOTP = () => {
		let data = {
			'mobileNumber': "+91" + this.props.user_details.mobileNumber
		}
		this.setState({
			seconds: 60
		});
		let scope = this;
		RequestOtpMutation(data, function (response) {
			if (response.requestOtp.error === false) {
				scope.startTimer();
				cogoToast.success("OTP sent again", {position: 'top-center'});
			} else {
				cogoToast.error(response.requestOtp.message, {position: 'top-center'});
			}
		}, function (err) {
			cogoToast.error(err, {position: 'top-center'});
		});
	}
	goToPreviousPage = () => {
		this.props.handleLoginSteps(0);
		this.props.setLoginStep(0);
	}

	componentWillUnmount() {
		// fix Warning: Can't perform a React state update on an unmounted component
		this.setState = (state, callback) => {
			return;
		};
	}

	render() {
		const {numInputs, separator, isDisabled, hasErrored, isInputNum} = this.state;

		return (
			<MDBBox className="otp-form-component d-flex flex-column justify-content-between px-3 pt-4 pb-3">
				{/*<Slide right cascade opposite when={this.state.triggerState}>*/}
					<MDBBox style={{overflow: "hidden"}}>
						<LoginHeader
							handleBackClick={this.goToPreviousPage}
							handleCloseClick={this.goToPreviousPage}
						/>

						<MDBBox className={'elipse-section'}>
							<img src={Phone} alt={"altImage"} className={"phone-img"}/>
							{/*<Slide bottom delay={1000} distance={"1px"}>*/}
								<img src={open_envlope} alt={"altImage"} className={"mail-img "}/>
							{/*</Slide>*/}
							{this.state.otpChecked &&
							<img src={tick} alt={"altImage"} className={"bell-img "}/>
							}

							<img src={NetaLogo} alt={"altImage"} className={"neta-logo "}/>
							<img src={OpenMe} alt={"altImage"} className={"open-me "}/>
						</MDBBox>

						<MDBBox className="otp-form-section">
							<MDBTypography tag="p" className={"label my-2"}>Please enter the OTP sent to</MDBTypography>
							<MDBBox className={"d-flex align-items-center"}>
								<MDBTypography tag="h4"
								               className="user-phone-no my-2">+91{this.props.user_details.mobileNumber}</MDBTypography>
								{/*<MDBTypography tag={"a"} className="otp-send-again mb-0 mx-2"*/}
								{/*               onClick={this.goToPreviousPage}>(CHANGE)</MDBTypography>*/}
							</MDBBox>
							<OtpInput
								inputStyle={{
									width: '4rem',
									height: '4rem',
									marginTop: ' 8px',
									marginBotom: ' 8px',
									marginLeft: `0`,
									fontSize: '24px',
									fontWeight: 600,
									borderRadius: 12,
									border: '1px solid rgba(0,0,0,0.3)',
								}}
								numInputs={numInputs}
								isDisabled={isDisabled}
								hasErrored={hasErrored}
								errorStyle="error"
								onChange={this.handleOtpChange}
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										this.handleSubmit(e);
									}
								}}
								separator={<span>{separator}</span>}
								isInputNum={isInputNum}
								shouldAutoFocus={false}
							/>
							<MDBBox className="d-flex my-2 justify-content-between">
								<MDBBox
									className="d-flex align-items-center otp-expire-content-section align-items-center">
									<img src={Vector} alt="Vector" className="mr-2"/>
									{/*{*/}
									{/*	this.state.time.s === 0 &&  this.state.time.m === 0 ?*/}
									{/*		<p style={{color:"red"}} className="m-0" >OTP Expired*/}
									{/*			</p>*/}
									{/*		:*/}
											<MDBTypography tag="p" className="m-0">OTP Expires
												in {this.state.time.m}:{this.state.time.s}</MDBTypography>
									{/*}*/}

								</MDBBox>
								<MDBTypography tag={"p"} className="m-0 otp-send-again" onClick={this.reSendOTP}>Send
									again?</MDBTypography>
							</MDBBox>

						</MDBBox>

					</MDBBox>
				{/*</Slide>*/}
				<button className="btn verify-otp-btn text-white"
				        onClick={(e) => this.handleSubmit(e)}
					// id={"submitButton-otp"}
					    disabled={this.state.loading}
				>
					Verify through OTP
					<MDBIcon icon="angle-right" className="mx-2"/>
				</button>

			</MDBBox>
		);
	}
}

const mapStateToProps = state => ({
	user_details: state.UserReducer.user_details,
})
const mapDispatchToProps = dispatch => ({
	addUserData: data => dispatch(userLogin(data)),
	setLoginStep: data => dispatch(setLoginStep(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(OTPForm);
